import SHRoleDialog from './src/dialog.vue';

/* istanbul ignore next */
SHRoleDialog.install = function(Vue) {
  Vue.component('sh-role-dialog', SHRoleDialog);
};

export default SHRoleDialog;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/dialog/index.js